// extracted by mini-css-extract-plugin
export default {"b_u_adiv":"Btnundo_b_u_adiv__HSIki","pressed":"Btnundo_pressed__3VkYa","b_u_img":"Btnundo_b_u_img__Z1q6x"};